import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { getRichTextRendererOptions } from './richTextRendererOptions'

export const renderRichText = (json, lang) => {
  const options = getRichTextRendererOptions(lang)
  return documentToReactComponents(json, options)
}